import React from 'react';
const ListButton = ({ title, link = false, onClick = () => { } }) => {
    return (React.createElement("button", { type: "button", onClick: onClick, className: `
      bg-transparent
      border
      border-solid
      border-gray-300
      px-5
      py-2
      text-sm
      rounded-md
      w-auto
      hover:bg-gray-300
      focus:bg-gray-200
      whitespace-nowrap
      ${link ? 'text-blue-500 underline decoration-blue-500' : 'text-gray-700'}
    ` }, title));
};
export default ListButton;
